// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as EditProfileActions } from '../../edit-profile/duck';
import { actions as AlertActions } from '../../../alert/duck';
import EditProfile from '../components/EditProfile';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    isPutting: state.preferences.editProfile.isPutting,
    isUploadingImage: state.preferences.editProfile.isUploadingImage,
    putError: state.preferences.editProfile.putError,
    dataEditSuccessful: state.preferences.editProfile.dataEditSuccessful,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...EditProfileActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);



// WEBPACK FOOTER //
// ./src/modules/preferences/edit-profile/containers/EditProfileContainer.js